/// <reference path="../../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";

import * as Rest from "../../Generated/RestClient";
import {NavLinks, HeaderControl, SmallHeaderNavLinks, SearchControl, JumboHeadControl, resourceStrings} from "../../../../Intercom.ReactUI/Views/index";
import {clientAppSettings} from "../../Models/ClientAppSettings";
import {DropdownMenu, DropdownMenuItem} from "../../Views/DropdownMenu";
import {ControllerBase, isBrowserSupported} from "../Controllers/ControllerBase";
import {getSignInUrl} from "../../Utils/Links";
import {SearchablePageProps} from "./MasterPage";
import { IAnnouncements } from "../../DevPortalAppBase";

export interface MasterPageHeaderProps extends SearchablePageProps {
    controller: ControllerBase;
    showLinks: boolean;
    showJumboHeader: boolean;
    showUserMenu: boolean;
    showSearch: boolean;
    showEnvironment: boolean;
    showMainNavLink: boolean;
    isReviewer: () => boolean;
    isAdmin: () => boolean;
    signedInUser: () => Rest.AuthData;
    renderHiddenFrameToCheckAzureSingleSignOn: () => JSX.Element;
    onSignOutClicked: () => void;
    onAccountClicked: () => void;
    isRoutableUrl: (url: string) => boolean;
    announcements: IAnnouncements;
}

export interface MasterPageHeaderState {
    searchString?: string;
    expandSearch?: boolean;
}

function SeverityEnumToIcon(s: Rest.AnnouncementSeverity): string {
    switch (s) {
        case Rest.AnnouncementSeverity.Error:
            return 'm-icon-AlertCircle severity-error';
        case Rest.AnnouncementSeverity.Good:
            return 'm-icon-CompletedSolid severity-good';
        case Rest.AnnouncementSeverity.Information:
            return 'm-icon-InfoSolid severity-info';
        case Rest.AnnouncementSeverity.Warning:
            return 'm-icon-AlertTriangle severity-warn';
    }
    return '';
}

function SeverityEnumToText(s: Rest.AnnouncementSeverity): string {
    switch (s) {
        case Rest.AnnouncementSeverity.Error:
            return resourceStrings.announcements.types.error;
        case Rest.AnnouncementSeverity.Good:
            return resourceStrings.announcements.types.good;
        case Rest.AnnouncementSeverity.Information:
            return resourceStrings.announcements.types.info;
        case Rest.AnnouncementSeverity.Warning:
            return resourceStrings.announcements.types.warn;
    }
    return '';
}

export class MasterPageHeader extends React.Component<MasterPageHeaderProps, MasterPageHeaderState> {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    private smallHeaderNavClick(index) {
        switch (index) {
            case SmallHeaderNavLinks.root:
                this.props.controller.app.navigate('/');
                break;
            case SmallHeaderNavLinks.mybots:
                this.props.controller.app.navigate('/bots');
                break;
            case SmallHeaderNavLinks.documentation:
                window.open('https://docs.microsoft.com/en-us/bot-framework/', '_blank');
                break;
            case SmallHeaderNavLinks.blog:
                window.open('https://blog.botframework.com', '_blank');
                break;
            case SmallHeaderNavLinks.register:
                this.props.controller.app.navigate('/bots/new');
                break;
            case SmallHeaderNavLinks.create:
                this.props.controller.app.navigate('/bots/provision');
                break;
        }
    }

    private toggleSearch() {
        var opened = _.isUndefined(this.state.expandSearch) ? true : !this.state.expandSearch;
        this.setState(_.extend(this.state, { expandSearch: opened }));
    }

    render(): JSX.Element {
        let navLinks: string[] = [];
        let bell = null as JSX.Element;
        let userInfo = null as JSX.Element;
        let searchControl = null as JSX.Element;

        const announcements = this.props.announcements && this.props.announcements.all || [];
        const announcementsIdCounts = this.props.announcements && this.props.announcements.shownIdCount || {};

        if (this.props.showLinks) {
            navLinks = [
                '/bots',
                'https://docs.microsoft.com/en-us/bot-framework/',
                clientAppSettings.homeUrl,
                'https://blog.botframework.com'
            ];

            if (this.props.showUserMenu && this.props.signedInUser) {
                let signedInUser = this.props.signedInUser();
                if (signedInUser) {
                    userInfo = (
                        <button className="signed-in-user rhs-nav" aria-label={`Account manager for ${signedInUser.FirstName || signedInUser.EmailAddress}`}>
                            <span>{signedInUser.FirstName || signedInUser.EmailAddress}</span>
                        </button>
                    );
                }
                else {
                    userInfo = (
                        <div className="header-login rhs-nav">
                            <a data-test-id="sign-in" className="header-sign-in-button"
                                onClick={evt => {
                                    if (!isBrowserSupported()) {
                                        evt.preventDefault();
                                        evt.stopPropagation();
                                        this.setState({ unsupportedBrowser: true } as any);
                                    }
                                }}
                                href={getSignInUrl()}>
                                Sign in
                            </a>
                            {this.props.renderHiddenFrameToCheckAzureSingleSignOn()}
                        </div>);
                }

                if (this.props.announcements && this.props.announcements.isFeatureFlighted) {
                    const hasUnreadAnnouncements = announcements.reduce((accumulator, current) => (accumulator || announcementsIdCounts[current.Id] == 0), false);
                    const bellIconId = hasUnreadAnnouncements ? "svgicon-bell-dot" : "svgicon-bell";
                    bell = (
                        <button className="header-announcement rhs-nav" aria-label="View notifications">
                            <svg className={"svgicon " + bellIconId}><use xlinkHref={"Client/Images/symbol-defs.svg#" + bellIconId}></use></svg>
                        </button>
                    );
                }
            }

            if (this.props.showSearch) {
                searchControl = this.props.isAdmin() || this.props.isReviewer() ? (
                    <SearchControl ref="searchBox" onSearch={this.props.onSearch}
                        value={null}
                        expandSearch={this.state.expandSearch}
                        promptText={clientAppSettings.searchPrompt}
                        toggleSearchOpen={_.debounce(_.bind(this.toggleSearch, this), 100, true) }/>
                ) : null;
            }
        }

        let userMenu: JSX.Element = null;
        if (this.props.showUserMenu && this.props.signedInUser) {
            let signedInUser = this.props.signedInUser();
            if (signedInUser) {
                userMenu = (
                    <DropdownMenu ref="userMenu" classNames="user-menu">
                        <DropdownMenuItem classNames="user-menu-user" ariaLabel={`account setting for ${signedInUser.FirstName || signedInUser.EmailAddress}`} onSelected={this.props.onAccountClicked}>
                            <div className="user-menu-user-name">{signedInUser.FirstName} {signedInUser.LastName}</div>
                            <div className="user-menu-user-email">{signedInUser.EmailAddress}</div>
                        </DropdownMenuItem>
                        <DropdownMenuItem classNames="user-menu-signout" ariaLabel={`sign out for ${signedInUser.FirstName || signedInUser.EmailAddress}`} onSelected={() => this.props.onSignOutClicked() }>
                            Sign out
                        </DropdownMenuItem>
                    </DropdownMenu>
                );
            }
        }

        const announcementsMenuItem = (a: Rest._Announcement) => {
            const link = a.LinkUrl ? <div className="announcement-link"><a href={a.LinkUrl} target="_blank">{resourceStrings.announcements.link}</a></div> : null;

            const classNames = 'announcement ' + (announcementsIdCounts[a.Id] < 2 ? "unread" : "read");
            return (
                <DropdownMenuItem key={a.Id} classNames={classNames} notSelectable={true}>
                    <div className="announcement-severity">
                        <span className={'announcement-icon ' + SeverityEnumToIcon(a.Severity)}></span>
                        {SeverityEnumToText(a.Severity)}
                    </div>
                    <div className="announcement-area">
                        {a.ProductArea}
                    </div>
                    <div className="announcement-body">
                        {a.Text}
                    </div>
                    {link}
                </DropdownMenuItem>
            );
        }

        const announcementsMenu = (
            <DropdownMenu ref="announcementsMenu" classNames={"user-menu" + (this.props.showJumboHeader ? '' : ' small-header-menu')}>
                {announcements.length > 0 ? announcements.map(announcementsMenuItem) : announcementsMenuItem({ Id: "0", Severity: Rest.AnnouncementSeverity.Good, ProductArea: resourceStrings.announcements.ok.productArea, Text: resourceStrings.announcements.ok.text })}
            </DropdownMenu>
        );

        let jumboHeader = (this.props.showJumboHeader) ? (
            <JumboHeadControl
                ref="jumbo"
                rootUrl={clientAppSettings.homeUrl || '/'}
                defaultLink={NavLinks.root}
                navLinks={navLinks}
                hideDirectory={true}
                isRoutable={this.props.isRoutableUrl}
            >
                {searchControl}
            </JumboHeadControl>
        ) : null;

        let features = clientAppSettings.flightedFeatures || [];
        let environment = (this.props.showEnvironment) ? clientAppSettings.environment : null;
        const skipToMainClick = (ev: React.MouseEvent<HTMLElement>) => {
            ev.preventDefault();
            location.hash="";
            location.hash="#page-content";
        }
        return (
            <div>
                {/* href do not works here */}
                <a href="javascript:void(0)" className="skipToMain" onClick={skipToMainClick}>Skip to main content</a>
                <HeaderControl
                    smallHeader={!this.props.showJumboHeader}
                    features={features}
                    showMainNavLink={this.props.showMainNavLink}
                    smallHeaderNavHandler={(index) => this.smallHeaderNavClick(index)}
                    environment={environment}>
                    {this.props.showJumboHeader ? null : searchControl}
                    <div className="rhs">
                        {userMenu}
                        {announcementsMenu}
                        {bell}
                        {userInfo}
                    </div>
                </HeaderControl>
                {jumboHeader}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/MasterPageHeader.tsx